/**
 * Year Limits Section
 * Sub-component of PreferencesModal for show year checkboxes and cutoff year select.
 */
import type { UserPreferences } from '../../types';

export interface YearLimitsSectionProps {
  preferences: UserPreferences;
  onPreferencesChange: (updated: UserPreferences) => void;
}

export function YearLimitsSection({ preferences, onPreferencesChange }: YearLimitsSectionProps) {
  // Generate year options (current year down to 1970)
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: currentYear - 1969 }, (_, i) => currentYear - i);

  return (
    <div className="p-3 space-y-3">
      {/* Show Year for Education */}
      <label className="flex items-center justify-between p-2 bg-gray-50 rounded-lg cursor-pointer">
        <span className="text-sm text-gray-700">Show Year for Education Items</span>
        <input
          type="checkbox"
          checked={preferences.show_year_education || false}
          onChange={(e) => onPreferencesChange({ ...preferences, show_year_education: e.target.checked })}
          className="w-4 h-4 text-primary-600 rounded border-gray-300 focus:ring-primary-500"
        />
      </label>

      {/* Show Year for Awards */}
      <label className="flex items-center justify-between p-2 bg-gray-50 rounded-lg cursor-pointer">
        <span className="text-sm text-gray-700">Show Year for Award Items</span>
        <input
          type="checkbox"
          checked={preferences.show_year_awards || false}
          onChange={(e) => onPreferencesChange({ ...preferences, show_year_awards: e.target.checked })}
          className="w-4 h-4 text-primary-600 rounded border-gray-300 focus:ring-primary-500"
        />
      </label>

      {/* Show Year for Presentations */}
      <label className="flex items-center justify-between p-2 bg-gray-50 rounded-lg cursor-pointer">
        <span className="text-sm text-gray-700">Show Year for Presentation Items</span>
        <input
          type="checkbox"
          checked={preferences.show_year_presentations || false}
          onChange={(e) => onPreferencesChange({ ...preferences, show_year_presentations: e.target.checked })}
          className="w-4 h-4 text-primary-600 rounded border-gray-300 focus:ring-primary-500"
        />
      </label>

      {/* Cutoff Year */}
      <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
        <span className="text-sm text-gray-700">Remove data that ended before</span>
        <select
          value={preferences.cutoff_year || ''}
          onChange={(e) => onPreferencesChange({
            ...preferences,
            cutoff_year: e.target.value ? parseInt(e.target.value) : undefined
          })}
          className="px-2 py-1 border border-gray-300 rounded text-sm focus:ring-primary-500 focus:border-primary-500"
        >
          <option value="">No cutoff</option>
          {yearOptions.map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>
    </div>
  );
}
